import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getColor, getLevel } from '../styles/helper'
import { parseMarginOrPadding } from '@helpers'

const propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'div'])
}

const Heading = styled.h1.attrs((props) => {
  props.palette = props.palette || 'text'
  let temp = {
    level: props.level || getLevel(props),
    as: props.as || getLevel(props),
    color:
      props.theme.palette.text[props.color] ||
      props.theme.palette[props.palette][props.color] ||
      (props.color ? props.color : getColor(props))
  }
  if(props.toc) {
    temp['data-toc'] = props.toc;
  }
  if(props.itemProp) {
    temp['itemprop'] = props.itemProp
  }
  return temp
})`
  color: ${(props) => props.color};
  text-align: ${(props) => (props.center ? 'center' : undefined)};
  font-weight: ${(props) => props.theme.typography[props.level].fontWeight};
  font-family: ${(props) => props.theme.typography[props.level].fontFamily};
  font-size: ${(props) => props.theme.typography[props.level].fontSize}em;
  text-transform: ${(props) =>
    props.theme.typography[props.level].case || 'none'};
  letter-spacing: ${(props) => props.theme.typography[props.level].spacing}em;
  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  padding: ${({ padding }) => parseMarginOrPadding(padding)};
  max-width: ${(props) => props.width || undefined};
  line-height: ${(props) => props.lineHeight};
  scroll-margin-top: 150px;
`

Heading.propTypes = propTypes
export default Heading
